import GauQuiz from 'components/GauQuiz';
import Lesson from 'components/Lesson';
import React from 'react'
import cat1 from "./img/cat1.png"
import cat2 from "./img/cat2.jpg"
import cat3 from "./img/cat3.jpg"
import cat4 from "./img/cat4.jpg"
import State4 from './State4';
import State5 from './State5';

function State1({ setNextState }) {
    return <GauQuiz messages={[
        "Xin chào!!",
        "Tớ là gấu!",
        "Tớ là một AI!",
        "Vậy AI là gì?",
    ]} question={{
        question: "AI là gì?",
        answers: [
            { message: "Là một Robot thông minh", correct: true },
            { message: "Là một con người", correct: false },
            { message: "Là một con mèo", correct: false },
            { message: "Là một con gấu", correct: false },
        ],
        correctMessage: "Đúng rồi, AI là một robot thông minh các bạn nhé!",
        onCorrect: () => {
            setNextState(true);
        }
    }}/>
}

function State2({ setNextState }) {
    return <GauQuiz messages={[
        "Vậy thì, cậu có biết",
        "AI do ai tạo ra không?",
    ]} question={{
        question: "AI do ai tạo ra?",
        answers: [
            { message: "Do một AI khác tạo ra", correct: false },
            { message: "Do con người tạo ra", correct: true },
            { message: "Do một con mèo tạo ra", correct: false },
            { message: "Do một con gấu tạo ra", correct: false },
        ],
        correctMessage: "Đúng rồi, AI là do con người tạo ra các bạn nhé!",
        onCorrect: () => {
            setNextState(true);
        }
    }}/>
}

function State3({ setNextState }) {
    return <GauQuiz messages={[
        "Cậu có biết là",
        "AI có thể tạo ra ảnh được không!",
        "Theo cậu thì",
        "Đâu là ảnh do AI tạo ra?",
    ]} question={{
        question: "Đâu là ảnh do AI tạo ra??",
        answers: [
            { img: cat1, correct: true },
            { img: cat2, correct: false },
            { img: cat3, correct: false },
            { img: cat4, correct: false },
        ],
        correctMessage: "Đúng rồi, đây là ảnh do AI tạo ra, AI đôi khi sẽ vẽ sai!",
        onCorrect: () => {
            setNextState(true);
        }
    }}/>
}

const states = [
    State1,
    State2,
    State3,
    State4,
    State5,
]

export default function Buoi1() {
    return <Lesson states={states} nextState />
}
